import { render, staticRenderFns } from "./objectCloseView.vue?vue&type=template&id=b7334ae4&"
import script from "./objectCloseView.vue?vue&type=script&lang=js&"
export * from "./objectCloseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports